var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-left pl-6"},[_c('div',{staticClass:"shop-name"},[_vm._v(" "+_vm._s(_vm.agencyFullName)+" ")])]),_c('menu-box',{attrs:{"menuItems":_vm.menuItems,"isMarginTop":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }